import ChallengeProduct from './ChallengeProduct';

export default ChallengeProduct;
